import React, { Suspense, useEffect, useRef, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
// import ScheduledMeeting from "./ScheduledMeeting";
import { useHeaderTitle } from "../../../context/HeaderTitleContext";
import DraftMeetings from "./DraftMeetings";
import CompletedMeetings from "./CompletedMeetings";
import { useMeetings } from "../../../context/MeetingsContext";
import moment from "moment";
import { useTabs } from "../../../context/TabContext";
import SignIn from "../AuthModal/SignIn";
import SignUp from "../AuthModal/SignUp";
import ForgotPassword from "../AuthModal/ForgotPassword";
import NewMeetingModal from "./CreateNewMeeting/NewMeetingModal";
import { useFormContext } from "../../../context/CreateMeetingContext";
import { useSteps } from "../../../context/Step";
import ReactToggle from "react-toggle";

const LazyComponent = React.lazy(() => import("./ScheduledMeeting"));

const MeetingSubTab = () => {
  const [tab, setTab] = useState("tab1");

  const { searchTerm, setSearchTerm } = useOutletContext();
  const {
    updateSolutionSteps,
    setSolutionType,
    setSolutionAlarm,
    setSolutionNote,
    setSolutionFeedback,
    setSolutionShareBy,
  } = useSteps();
  const { resetHeaderTitle } = useHeaderTitle();

  React.useEffect(() => {
    resetHeaderTitle();
  }, []);
  const { open, handleShow, handleCloseModal } = useFormContext();
  const location = useLocation();
  const [t] = useTranslation("global");

  const queryParams = new URLSearchParams(location.search);
  const fromPresentation2 = queryParams.get("from") === "presentation";
  const fromPresentation3 = queryParams.get("from") === "completeedit";

  const lastUrl = localStorage.getItem("lastURL");
  const {
    allMeetings,
    allDraftMeetings,
    getMeetings,
    getClosedMeetings,
    // getDraftMeetings,
    allClosedMeetings,
    getMeetingsCalculations,
    selectedFilter,
    offset,
    setOffset,
    setHasMore,

    setAllMeetings,
    setMeetingLength,
    selectedClosedFilter,

    closedOffset,

    draftOffset,

    activeMeetingCount,
    draftMeetingCount,
    closedMeetingCount,

    setAllClosedMeetings,
    setClosedMeetingLength,
    setClosedOffset,
    setClosedHasMore,

    // setAllDraftMeetings,
    // setDraftMeetingLength,
    // setDraftOffset,
    // setDraftHasMore,

    setAllEventMeetings,
    setAgendaEventLength,
    setAgendaEventHasMore,
    setAgendaEventOffset,
    agendaEventOffset,
    getAgendaEvents,
    selectedAgenda,

    getCombineMeetings,

    setCalendar,
    calendar,
    // agendaCount,
    getTektimeAgenda,

    getGoogleAgenda,

    getBothAgenda,
  } = useMeetings();

  const [filteredMeetings, setFilteredMeetings] = useState(allMeetings);

  // -------------------------------------------
  useEffect(() => {
    updateSolutionSteps([]);
    setSolutionType(null);
    setSolutionAlarm(false);
    setSolutionNote("Manual");
    setSolutionFeedback(false);
    setSolutionShareBy(null);
    setTab("tab1");
    if (fromPresentation2) {
      setTab("tab2");
    }
    // getMeetingsCalculations();
  }, []);
  //   const { activeTab, setActiveTab } = useTabs();

  // useEffect(() => {
  //   setAllMeetings([]);
  //   setMeetingLength(0);
  //   setHasMore(true);
  //   setOffset(0);

  //   getMeetings(); // Fetch meetings immediately after resetting offset
  // }, [location.key]); // Runs when the page is revisited

  useEffect(() => {
    setAllMeetings([]);
    setMeetingLength(0);
    setHasMore(true);
    setOffset(0);

    if (tab === "tab1" && selectedAgenda.tektime && selectedAgenda.google) {
      getCombineMeetings(false); // Call when both are selected
    } else if (selectedAgenda.tektime && !selectedAgenda.google) {
      getMeetings(); // Fetch meetings
    }
  }, [selectedAgenda,tab]); // Runs when selectedAgenda changes

  useEffect(() => {
    if (offset > 0) {
      // Only fetch when offset is increased (for scrolling)
      if (selectedAgenda.tektime && !selectedAgenda.google) {
        getMeetings();
      } else if (selectedAgenda.tektime && selectedAgenda.google) {
        getCombineMeetings(false); // Call when both are selected
      }
    }
  }, [offset]);

  useEffect(() => {
    setOffset(0);
    setClosedOffset(0);
    setAgendaEventOffset(0);
    setSearchTerm("");

  }, [tab]);


  //Agenda Events
  useEffect(() => {
    // setAllEventMeetings([]);
    // setAgendaEventLength(0);
    // setAgendaEventHasMore(true);
    // setAgendaEventOffset(0);

    setAllMeetings([]);
    setMeetingLength(0);
    setHasMore(true);
    setOffset(0);
    if (selectedAgenda.google && !selectedAgenda.tektime) {
      getAgendaEvents();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (selectedAgenda.google && !selectedAgenda.tektime) {
      if (offset > 0) {
        getAgendaEvents();
      }
    }
  }, [agendaEventOffset]);

  useEffect(() => {
    setAllClosedMeetings([]);
    setClosedMeetingLength(0);
    setClosedHasMore(true);
    setClosedOffset(0);
    getClosedMeetings();
  }, [location.pathname]);

  useEffect(() => {
    if (closedOffset) {
      getClosedMeetings();
    }
  }, [closedOffset]);

//   useEffect(() => {
//     setAllDraftMeetings([]);
//     setDraftMeetingLength(0);
//     setDraftHasMore(true);
//     setDraftOffset(0);
//     getDraftMeetings();
//   }, [tab]);

//   useEffect(() => {
//     if (draftOffset) {
//       getDraftMeetings();
//     }
//   }, [draftOffset]);

  const tabsRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  // const [activeTab, setActiveTab] = useState("tab2");

  const handleScroll = () => {
    if (tabsRef.current) {
      setIsSticky(window.scrollY > 100);
    }
  };

  useEffect(() => {
    // window.addEventListener("scroll", handleScroll);
    // return () => {
    //   window.removeEventListener("scroll", handleScroll);
    // };
  }, []);

  const [draftMeetings, setDraftMeetings] = useState(allDraftMeetings);
  const [closedFilteredMeetings, setClosedFilteredMeetings] =
    useState(allClosedMeetings);

  const userId = parseInt(sessionStorage.getItem("user_id"));
  useEffect(() => {
    let filtered = [...allMeetings];

    // Further filter the meetings based on status and user_id
    filtered = filtered.filter(
      (meeting) =>
        meeting.status === "active" || meeting.status === "in_progress" || meeting?.status === "to_finish" || meeting?.status === "todo"
      //  &&  meeting.user_id === userId
    );
    // let myClosedMeetings = allClosedMeetings.filter(
    //   (meeting) => meeting.user_id === userId
    // );
    let myClosedMeetings = [...allClosedMeetings];

    let draftMeetings = allDraftMeetings?.filter(
      (meeting) => meeting.status === "draft"
    );
    if (searchTerm) {
      filtered = filtered.filter((meeting) =>
        meeting.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      myClosedMeetings = myClosedMeetings.filter((meeting) =>
        meeting.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      draftMeetings = draftMeetings?.filter(
        (meeting) =>
          meeting?.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          meeting?.objective?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setDraftMeetings(draftMeetings);
    setFilteredMeetings(filtered);
    setClosedFilteredMeetings(myClosedMeetings);
  }, [
    selectedFilter,
    selectedClosedFilter,
    allMeetings,
    allDraftMeetings,
    userId,
    allClosedMeetings,
    searchTerm,
  ]);

  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  const handleShowSignIn = () => {
    setShowSignUp(false);
    setShowSignIn(true);
  };

  const handleShowSignUp = () => {
    setShowSignIn(false);
    setShowSignUp(true);
  };

  const handleShowForgot = () => {
    setShowSignIn(false);
    setShowSignUp(false);
    setShowForgot(true);
  };

  const handleCloseSignIn = () => setShowSignIn(false);
  const handleCloseSignUp = () => setShowSignUp(false);
  const handleCloseForgot = () => setShowForgot(false);

  useEffect(() => {
    console.log("false");
    // When selectedAgenda changes, reset calendar to false
    // setCalendar(false);
  }, [selectedAgenda]);

  return (
    <div className="tabs-container">
      <div className="border-bottom tabs-meeting">
        <div className="tabs" style={{ overflowX: "auto" }}>
          <div className="d-flex">
            <button
              className={`tab ${tab === "tab1" ? "active" : ""}`}
              onClick={() => setTab("tab1")}
            >
              {t("meeting.activeMeetingsTab")}
              <span className={tab === "tab1" ? "future" : "draft"}>
                {activeMeetingCount}
              </span>
            </button>
            <button
              className={`tab ${tab === "tab2" ? "active" : ""}`}
              onClick={() => setTab("tab2")}
            >
              {t("meeting.completedMeetingsTab")}
              <span className={tab === "tab2" ? "future" : "draft"}>
                {closedMeetingCount}
              </span>
            </button>
          </div>
        </div>
      </div>

      <div className="content">
        {tab === "tab1" && (
          <div>
            <Suspense fallback={<div>Loading...</div>}>
              <LazyComponent
                allMeetings={filteredMeetings}
                calendar={calendar}
                activeTab={tab}
                activeMeetingCount={activeMeetingCount}
                closedMeetingCount={closedMeetingCount}
              />
            </Suspense>
          </div>
        )}
        {tab === "tab2" && (
          <div>
            <CompletedMeetings
              allClosedMeetings={closedFilteredMeetings}
              calendar={calendar}
              activeTab={tab}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MeetingSubTab;
